import { createSelector } from 'reselect'

import { PostingRootState } from '../postingRoot.reducer'

export const getFacebookFeeds = createSelector(
  (state: PostingRootState) => state.facebookStore.facebookFeeds,
  (state) => state,
)

export const getFacebookPage = createSelector(
  (state: PostingRootState) => state.facebookStore.facebookPage,
  (state) => state,
)
